import type { Map as MapboxMap } from 'mapbox-gl';
import type { MapStyle } from '../MapControlsFAB';
import { applyCoordalCatalogIcons } from './applyCoordalIcons';
import { loadCoordalSvgIcon, clearCoordalSvgIconCache } from './coordalIconLoader';
import { findCatalogEntryById, catalogLayerPath, type IconTheme } from './iconCatalog';

export function iconThemeForMapStyle(mapStyle: MapStyle): IconTheme {
  return mapStyle === 'dark' ? 'dark' : 'standard';
}

/**
 * Register styleimagemissing + load catalog SVGs (POI/landmark). Returns cleanup.
 * Use from React hooks and from EmbedApp (no hook).
 */
export function attachCoordalCatalogIcons(
  map: MapboxMap,
  getMap: () => MapboxMap | null,
  iconTheme: IconTheme,
): () => void {
  clearCoordalSvgIconCache();

  const apply = () => {
    const activeMap = getMap();
    if (!activeMap?.isStyleLoaded()) return;
    void applyCoordalCatalogIcons(activeMap, iconTheme).catch((err) => {
      console.warn('[coordal-icons] apply failed:', err);
    });
  };

  const onStyleLoad = () => {
    clearCoordalSvgIconCache();
    getMap()?.once('idle', apply);
  };

  const onImageMissing = (e: { id: string }) => {
    const activeMap = getMap();
    if (!activeMap) return;
    const entry = findCatalogEntryById(e.id);
    if (!entry || entry.sprite) return;
    const basePath = catalogLayerPath(entry.layer, iconTheme);
    void loadCoordalSvgIcon(
      activeMap,
      entry.id,
      `${window.location.origin}${basePath}/${entry.file}`,
    ).catch(() => undefined);
  };

  map.on('styleimagemissing', onImageMissing);
  map.on('style.load', onStyleLoad);
  map.once('idle', apply);

  return () => {
    map.off('style.load', onStyleLoad);
    map.off('styleimagemissing', onImageMissing);
  };
}
